module.exports = __webpack_public_path__ + "img/icon_deal__tender@3x.5f5ae3cf.png";